// Zonas horarias por país (IANA). Para el selector de Preferencias.
// '' = usar la zona del dispositivo.
export interface TzOption {
  label: string;
  tz: string;
}

export const TIMEZONES: TzOption[] = [
  { label: 'La de mi dispositivo', tz: '' },
  { label: 'Argentina', tz: 'America/Argentina/Buenos_Aires' },
  { label: 'Uruguay', tz: 'America/Montevideo' },
  { label: 'Chile', tz: 'America/Santiago' },
  { label: 'Paraguay', tz: 'America/Asuncion' },
  { label: 'Bolivia', tz: 'America/La_Paz' },
  { label: 'Brasil (Brasilia)', tz: 'America/Sao_Paulo' },
  { label: 'Perú', tz: 'America/Lima' },
  { label: 'Ecuador', tz: 'America/Guayaquil' },
  { label: 'Colombia', tz: 'America/Bogota' },
  { label: 'Venezuela', tz: 'America/Caracas' },
  { label: 'México', tz: 'America/Mexico_City' },
  { label: 'EE.UU. — Este (NY)', tz: 'America/New_York' },
  { label: 'EE.UU. — Central', tz: 'America/Chicago' },
  { label: 'EE.UU. — Montaña', tz: 'America/Denver' },
  { label: 'EE.UU. — Pacífico (LA)', tz: 'America/Los_Angeles' },
  { label: 'Canadá — Este (Toronto)', tz: 'America/Toronto' },
  { label: 'España', tz: 'Europe/Madrid' },
  { label: 'Reino Unido', tz: 'Europe/London' },
];
